module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAASUlEQVR42u3XMQoAIAgFUE/fbYLO0aVqrSkwxyf8Vd4gohFHrdFWNlFRAFfT2d8BAAAAAKhe2QBfgIpZAQAAAAAAAPh5TrP3wAb+Eb026/uGLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/captadas_pluri_sin.png
// module id = 5cr3
// module chunks = 0